import CustomMenu from "../projectImages/custom-menu.png"
import ResponsivePizza from "../projectImages/Responsive-pizza.png"
import Lyrics from "../projectImages/Lyrics.png"
import ReactApi from "../projectImages/Githubapi.png"
import FoodieFrontPage from "../projectImages/Foodiefp.png"
import ReactTaskTracker from "../projectImages/TaskTracker.png"
import Counter from "../projectImages/Counter.png"
import Reviews from "../projectImages/Reviews.png"
import ColorFlipper from "../projectImages/ColorFlipper.png"
import ResponsiveTemplate from "../projectImages/Responsive-template.png"
import Ecommerce from "../projectImages/Ecommerce.png"
import Dailytask from "../projectImages/Dailytask.png"
import Textutility from "../projectImages/Textutility.png"

export const data = [{
    "id": 1,
    "title": "React Custom menu",
    "disc": "Custom menu with customize scrollbar",
    "img": CustomMenu,
    "link":"https://custom-menu4211.web.app/"
  },
  {
    "id": 2,
    "title": "React Textutility",
    "disc": "Text utility resposive react app with dark mode ",
    "img": Textutility,
    "link":"https://textutility-4211.web.app/"
  }, 
  {
    "id": 3,
    "title": "Ecommerce Design",
    "disc": "Ecommerce site design using React and styled components",
    "img": Ecommerce,
    "link":"https://ecommerce4211.web.app/"
  },
  {  
    "id": 4,
    "title": "Responsive Pizza",
    "disc": "Responsive pizza website included custom css",
    "img": ResponsivePizza,
    "link": "https://responsive-pizza.netlify.app/"
  }, {
    "id": 5,
    "title": "Lyrics",
    "disc": "Lyrics songs website custom design",
    "img": Lyrics,
    "link": "https://lyrics-4211.netlify.app/"
  }, {
    "id": 6,
    "title": " React Github api",
    "disc": "Github api data fetch",
    "img": ReactApi,
    "link": "https://hexcode4211.web.app/"
  }, {
    "id": 7,
    "title": "React Daily Task",
    "disc": "Todo list daily task custom css and responsive",
    "img":  Dailytask,
     "link":"https://todo-4211.web.app/"
  }, {
    "id": 8,
    "title": " React Task Tracker",
    "disc": "task sechdule app",
    "img": ReactTaskTracker,
    "link":"https://tasktracker4211.web.app/"
  }, {
    "id": 9,
    "title": "Counter",
    "disc": "Counter app HTML5,CSS,and JS",
    "img": Counter,
    "link": "https://counter-4211.netlify.app/"
  }, {
    "id": 10,
    "title": "Hexcode4211-reviews",
    "disc": "Review slider customize",
    "img": Reviews,
    "link":"https://hexcode4211-review.netlify.app/"
  }, {
    "id": 11,
    "title": "Color Flipper",
    "disc": "Color Flipper Color Randomizer",
    "img": ColorFlipper,
    "link": "https://colorflipper-4211.netlify.app/"
  }, {
    "id": 12,
    "title": "Responsive web Template",
    "disc": "A responsive website template for portfolio",
    "img":  ResponsiveTemplate,
     "link":"https://responsive-webtemplate.netlify.app/"
  },
  {
    "id": 13,
    "title": "Foodie Frontpage",
    "disc": "Food Responsive website custom webpage with custom scrollbar.",
    "img": FoodieFrontPage,
    "link":"https://foodie-frontpage.netlify.app/"
  },
]